import { SplitContext, SplitFactory } from "@splitsoftware/splitio-react";
import { useContext } from "react";

import { SPLIT_KEY } from "./constants";

enum FeatureFlags {
  EG_5040 = "EG-5040_psd2_new_experience",
}

const USER_ID = "key";
const sdkConfig = {
  core: {
    authorizationKey: SPLIT_KEY,
    key: USER_ID,
  },
};

const useFeatureFlag = (
  featureFlag: string,
  options?: { companyId: string; country: string }
) => {
  const { client, isReady } = useContext(SplitContext);

  const treatment = client?.getTreatment(featureFlag, {
    companyId: options?.companyId || "",
    country: options?.country || "",
  });

  return { isReady, isEnabled: treatment === "on" };
};

const FeatureFlagsProvider = ({ children }: { children: JSX.Element }) => {
  return <SplitFactory config={sdkConfig}>{children}</SplitFactory>;
};

export { useFeatureFlag, FeatureFlagsProvider, FeatureFlags };
